import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './views';
import './index.css';


/* fix leaflet */
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const context = {
  inserCss: (...styles) => {
    const removeCss = styles.map(x => x._insertCss());
    return () => { removeCss.forEach(f => f()); };
  },
}

ReactDOM.render(
  <App context={context}></App>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js